import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.article`
  position: relative;
`;

export const FoldableArticle = styled.article<{ fold: boolean }>`
  padding: 16px 12px;
  color: #343434;
  font-size: 14px;
  font-weight: 400;
  vertical-align: baseline;
  font-stretch: normal;
  letter-spacing: normal;

  ${(props) => {
    if (!props.fold) {
      return ``;
    } else if (props.fold) {
      return css`
        height: 1400px;
      `;
    }
  }}
  overflow: hidden;

  figure {
    width: fit-content !important;

    &.media {
      width: 100% !important;

      iframe {
        width: 100%;
        height: 100%;
        aspect-ratio: 16 / 9;
      }
    }
  }

  figure + figure {
    margin-top: -2px;
  }

  img {
    width: 100% !important;
  }

  .text-tiny {
    font-size: 0.7em;
  }

  .text-small {
    font-size: 0.85em;
  }

  .text-big {
    font-size: 1.4em;
  }

  .text-huge {
    font-size: 1.8em;
  }
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 11px;
  cursor: pointer;
  position: sticky;
  top: 48px;
  background: white;
  padding-top: 10px;
  z-index: 1;
`;

export const Tab = styled.div<{ active: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 12px;

  ${(props) =>
    props.active
      ? `
      border-bottom: 2px solid black !important;
      
      .inpock-typography.paragraph-1 {
        color: black !important;
      }
    `
      : `
      border-bottom: 1px solid var(--color-ui-grayscale-gray-200) !important;

      .inpock-typography.paragraph-1 {
        color: var(--color-ui-grayscale-gray-200) !important;
      }
    `}

  .inpock-typography.paragraph-1 {
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const ReviewTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

export const ReviewTab = styled.div<{ active: boolean }>`
  padding-bottom: 15px;
  cursor: pointer;

  ${(props) =>
    props.active
      ? `      
      .inpock-typography.paragraph-2 {
        color: black !important;
      }
    `
      : `
      .inpock-typography.paragraph-2 {
        color: var(--color-ui-grayscale-gray-200) !important;
      }
    `}

  .inpock-typography.paragraph-2 {
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-weight: 700;
  }
`;
